import script from "./ExtrasCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExtrasCard.vue?vue&type=script&setup=true&lang=ts"

import "./ExtrasCard.vue?vue&type=style&index=0&id=cfeb59ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfeb59ae"]])

export default __exports__